import { SapiService } from './../../../services/sapi.service';
import { FlowchartStep } from './../../../shared/models/flowchart-step.model';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { Project } from './../../../interfaces/project';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { QueryParameter } from '../../../interfaces/queryString';

@Component({
	selector: 'library-project-details-embed',
	templateUrl: './library-project-details-embed.component.html',
	styleUrls: ['./library-project-details-embed.component.scss']
})


export class LibraryProjectDetailsEmbedComponent implements OnInit, OnChanges {

	@Input() project: Project;
	@Input() form: NgForm;
	@Input() mainMediaClip: Mediaclip;
	@Input() isActive: boolean;

	draftClips: Mediaclip[];

	constructor(private sapiService: SapiService) {

	}

	ngOnInit() {
		this.draftClips = [];
		this.draftClips.push(this.mainMediaClip);
		this.draftClips = this.getDraftClips();
	}

	ngOnChanges(changes: SimpleChanges) { // runs every time tab is clicked
		if (typeof changes.isActive !== 'undefined' && !changes.isActive.firstChange) {
			if (changes.isActive.currentValue === true) {
				this.draftClips = this.getDraftClips();
			}
		}
	}

	public publishProject(): void {
		if (this.project && this.project.status) {
			this.project.status = 'published';
			this.form.form.markAsDirty();
		}
	}

	private getDraftClips(): Mediaclip[] {
		const clips: Mediaclip[] = [];
		const clipIds: string[] = [];

		if (this.project && this.project.flowchart && this.project.flowchart.steps) {
			Object.keys(this.project.flowchart.steps).forEach((stepId: string) => {
				const step: FlowchartStep = this.project.flowchart.steps[stepId];
				if (step.entityType && step.entityType === 'mediaclip' && step.entityId) {
					clipIds.push(step.entityId);
				}
			});
		}
		if (clipIds.length > 0) {
			this.loadClips(clipIds);
		}
		return clips;
	}

	private loadClips(clipIds: string[]): void {
		let query = '';

		for (let i = 0, l = clipIds.length; i < l; i++) {
			if (!query.includes(`"${clipIds[i]}"`)) {
				query += `id:"${clipIds[i]}"`;
				if (i < l - 1) {
					query += ' OR ';
				}
			}
		}

		const queryParams: QueryParameter[] = [];
		queryParams.push({ name: 'q', values: [query] } as QueryParameter);
		this.sapiService.query('mediaclip', queryParams).subscribe(response => {
			if (response && response.items && response.items.length > 0) {
				for (let i = 0, l = response.items.length; i < l; i++) {
					if (response.items[i] && response.items[i].status && response.items[i].status === 'draft') {
						this.draftClips.push(response.items[i]);
					}
				}
			}
		});
	}
}
